import { render, staticRenderFns } from "./HotBuy.vue?vue&type=template&id=4a54e22e&scoped=true&"
import script from "./HotBuy.vue?vue&type=script&lang=js&"
export * from "./HotBuy.vue?vue&type=script&lang=js&"
import style0 from "./HotBuy.vue?vue&type=style&index=0&id=4a54e22e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a54e22e",
  null
  
)

export default component.exports